import { render, staticRenderFns } from "./perencanaan.vue?vue&type=template&id=43081524&"
import script from "./perencanaan.vue?vue&type=script&lang=js&"
export * from "./perencanaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports